import { useMemoizedFn as l } from "ahooks";
function o({
  onFocus: e
}) {
  return {
    onFocus: l((t) => {
      e == null || e(t);
      const n = t.target, s = n.value.length;
      n.setSelectionRange(s, s);
    })
  };
}
export {
  o as useFocusEndOfText
};
